// extracted by mini-css-extract-plugin
export var container = "TabContent-module--container--73393";
export var header = "TabContent-module--header--84c32";